import { makeStyles } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { Card, Grid } from '@material-ui/core';
import { REFUND_STATUSES } from 'constants/amcStatuses';

export const useStyles = makeStyles({
  root: {
    fontSize: '11px !important',
    border: '1px solid #E6E6E6',
    borderRadius: '6px',
    width: '98px !important',
    color: '#172C51 !important',
    '&:hover': {
      color: '#172C51 !important',
    },
  },
});
export const StyledCard = styled(({ ...otherProps }) => (
  <Card {...otherProps} />
))`
  background-color: #fff !important;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
  height: 164px !important;
  justify-content: center !important;
  align-items: center !important;
`;
export const StyledGrid = styled(
  ({ textAlign, marginBottom, ...otherProps }) => <Grid {...otherProps} />,
)`
  text-align: ${(props) => props.textAlign} !important;
  margin-bottom: ${(props) => props.marginBottom} !important;
  min-height: 150px !important;
`;
export const COLOR_BY_REFUND_STATUS: any = {
  [REFUND_STATUSES.RETURN]: 'warning',
  [REFUND_STATUSES.VISITE]: 'warning',
  [REFUND_STATUSES.AGREEMENT]: 'success',
  [REFUND_STATUSES.REJECTED]: 'error',
  [REFUND_STATUSES.PAIED]: 'success',
  [REFUND_STATUSES.PEC_CANCELED]: 'error',
  [REFUND_STATUSES.PENDING]: 'warning',
  [REFUND_STATUSES.COMPLEMENTARY_INFO]: 'warning',
  [REFUND_STATUSES.PEC]: 'warning',
  [REFUND_STATUSES.CI_ENCOURS]: 'warning',
  [REFUND_STATUSES.S_SUITE]: 'error',
  DEFAULT: 'warning',
};
